import React from 'react';
import CapacityPlantTemplate from '../../components/CapacityPlantTemplate';
import { capacityPlants } from '../../data/capacityPlants';

const WaterPlant24BPM = () => (
  <CapacityPlantTemplate plant={capacityPlants['/24-bpm-water-plant']} path="/24-bpm-water-plant" />
);

export default WaterPlant24BPM;
